import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import WhnArticlesContainer from "./WhnArticlesContainer";
import { IArticlesItem } from "../../interfaces";
import store, { RootState } from "../../../../store/index";
import { getWhnArticles } from "../actions";
import { chunkArray } from "utils";
import MyAccountsArticles from "modules/Content/MyAccounts/Components/myAccountsArticles";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import WhnPlaceholder from "./WhnPlaceholder";
import ListPlaceholder from "./ListPlaceholder";
import SelectedBottom from "modules/Common/Components/SelectedBottom";
import { removeSelectedIds } from "modules/Content/DragnDrop/actions";
import { PREVIEW_ARTICLE } from "constants/actionTypes";
interface WhatsHappeningNowTabProps {
  isListView: boolean;
  inEditionSmartSourced?: boolean;
}
const WhatsHappeningNowTab: React.FC<WhatsHappeningNowTabProps> = ({
  isListView,
  inEditionSmartSourced,
}: WhatsHappeningNowTabProps) => {
  /* Whats happening tab */
  const DEFAULT_PAGE_LIMIT = 21;
  const FIRST_PAGE_LIMIT = 11;

  const articles: IArticlesItem[] = useSelector((state: RootState) => state.whnArticles.data);
  const loading: boolean = useSelector((state: RootState) => state.whnArticles.loading);
  const page: number = useSelector((state: RootState) => state.whnArticles.page);
  const selectedIds = useSelector((state: RootState) => state.dragDrop.selectedIds);

  const getPagination = () => {
    let offset = page > 0 ? articles.length : 0;
    let limit = page > 0 ? DEFAULT_PAGE_LIMIT : FIRST_PAGE_LIMIT; //update to 22

    return { result_offset: offset, result_limit: limit };
  };

  useEffect(() => {
    if (page === 0 && !loading) getWhnArticles(getPagination());
    window.scrollTo(0, 0);
    store.dispatch({
      type: PREVIEW_ARTICLE.RESET_SEARCH_TERMS,
    });
  }, []);

  const loadMore = () => {
    if (!loading) getWhnArticles(getPagination());
  };

  return (
    <TabOneStyle>
      <InfiniteLoader
        dataLength={articles.length}
        next={loadMore}
        hasMore={true}
        loader={
          isListView ? (
            <ListPlaceholder loading={loading} />
          ) : (
            <div className="padding-top-md">
              <WhnPlaceholder loading={loading} />
            </div>
          )
        }
      >
        <>
          <WhnArticlesContainer
            inEditionSmartSourced={inEditionSmartSourced}
            articles={articles.slice(0, FIRST_PAGE_LIMIT)}
            isListView={isListView}
          />
          {chunkArray(articles.slice(FIRST_PAGE_LIMIT), DEFAULT_PAGE_LIMIT).map((subArtilces, index) => (
            <MyAccountsArticles
              inEditionSmartSourced={inEditionSmartSourced}
              key={index}
              articles={subArtilces}
              isListView={isListView}
            />
          ))}
        </>
      </InfiniteLoader>
      <SelectedBottom
        hideAction={true}
        selectedCount={selectedIds?.length}
        selectedMessage={` ${selectedIds.length === 1 ? "article" : "articles"} selected`}
        onClearSelection={removeSelectedIds}
      />
      <div id="load-controls" className="d-none"></div>
      <div id="load-template" className="d-none"></div>
    </TabOneStyle>
  );
};

export default WhatsHappeningNowTab;

const TabOneStyle = styled.div`
  margin-top: 0;
  padding-top: 0;
  display: inline-block;
  .first-caption {
    display: flex;
    justify-content: center;
    align-items: center;
    h3 {
      font-size: 44px;
      font-family: roboto_slabregular, serif;
      color: #424b50;
      font-weight: bold;
      line-height: 1;
    }
  }
`;
